import styled from "styled-components";
import { makeStyles } from "@material-ui/core/styles";
import { colors } from "../../../../components/theme";

export const Wrapper = styled.div`
  width: 100%;
  min-height: 44px;
  height: auto;
  border-radius: 4px;
  margin-top: 20px;
  display: inline-block;
`;

export const WrapperIcon = styled.div`
  width: 38px;
  height: 36px;
  border-radius: 4px;
  margin-right: 12px;
  float: left;
  cursor: pointer;
`;

export const WrapperIconNoMargin = styled.div`
  width: 38px;
  height: 36px;
  border-radius: 4px;
  float: left;
  cursor: pointer;
`;
export const WrapperPathMapUl = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  float: left;
`;

export const WrapperPathMapLi = styled.li`
  float: left;
  padding: 0;
  margin: 9px 0 0 10px;
  color: #0076ff;
  cursor: pointer;
`;

export const WrapperPathMapSpan = styled.span`
  margin-right: 9px;
`;

export const useStyles = makeStyles((theme) => ({
  inActiveTree: {
    backgroundColor: "#fff",
  },
  activeTree: {
    backgroundColor: "#0076FF",
  },
  refresh: {
    backgroundColor: "rgb(251, 167, 48)",
    padding: "9px",
  },
  downloadZip: {
    backgroundColor: colors.white,
    padding: "9px",
  },
  optionMenu: {
    border: "1px #0076FF3 solid",
    padding: "9px",
    marginLeft: "13px",
    backgroundColor: "#fff",
  },
  rootFolder: {
    backgroundColor: "#fff",
    width: 38,
    height: 36,
    borderRadius: 4,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 0,
    float: "left",
  },

  iconRefresh: {
    fontSize: "18px",
    color: "#fff",
  },
  up: {
    backgroundColor: "#fff",
    padding: "9px",
  },
  iconUp: {
    fontSize: "18px",
    paddingLeft: "1px",
    color: "#0076FF",
  },
  btnUpload: {
    textAlign: "right",
    marginTop: "5px",
  },
  PathMapCreateFolder: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
    cursor: "pointer",
    display: "block",
    margin: 0,
    padding: 0,
  },

  PathActive: {
    color: "#8b8b8b !important",
  },
  recentFilesActive: {
    border: "1px #0076FF3 solid",
    padding: "9px",
    marginLeft: "13px",
    backgroundColor: "#0076FF",
    color: "#fff !important",
  },
  recentFilesInActive: {
    border: "1px #0076FF3 solid",
    padding: "9px",
    marginLeft: "13px",
    backgroundColor: "#fff",
    color: "#8b8b8b !important",
  },
}));
